module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-player",
    class: {
      'no-album': !_vm.item
    }
  }, [_c('canvas', {
    staticClass: "player-background",
    attrs: {
      "id": "canvas"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "_top dflex align-center justify-space-between"
  }, [_vm._m(0), _vm._v(" "), _c('v-icon', {
    staticClass: "min-player",
    on: {
      "click": function($event) {
        _vm.minModal()
      }
    }
  }, [_vm._v(" expand_more ")])], 1), _vm._v(" "), (_vm.item) ? _c('div', {
    staticClass: "album-track-details"
  }, [_c('div', {
    staticClass: "album-cover",
    style: ({
      'background-image': 'url(' + _vm.albumCover + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "track-info"
  }, [_c('div', {
    staticClass: "track-name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    staticClass: "track-artist"
  }, [_vm._v(_vm._s(_vm.item.user.username))])]), _vm._v(" "), (_vm.isLoaded) ? _c('div', {
    staticClass: "loading flex-none",
    attrs: {
      "id": "loading"
    }
  }) : _c('div', {
    staticClass: "controls-section"
  }, [_c('div', {
    staticClass: "bar-section"
  }, [_c('v-spacer', [_c('v-slider', {
    staticClass: "player-bar pa-0",
    attrs: {
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.seek(_vm.progress)
      }
    },
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "duration-time total",
    attrs: {
      "id": "totalTime"
    }
  }, [_vm._v(_vm._s(_vm.totalTime))])], 1), _vm._v(" "), _c('div', {
    staticClass: "action-btns"
  }, [_c('v-btn', {
    staticClass: "player-control-btn no-Btn-bg",
    attrs: {
      "ripple": false,
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.skip('prev')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_rewind.svg",
      "width": "20"
    }
  })]), _vm._v(" "), (!_vm.isPlaying) ? _c('v-btn', {
    staticClass: "player-control-btn play no-Btn-bg",
    attrs: {
      "ripple": false,
      "flat": "",
      "id": "play"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$root.$emit(_vm.MyEvents.AUDIO_PLAYER_REPLAY)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_play.svg",
      "height": "26"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isPlaying) ? _c('v-btn', {
    staticClass: "player-control-btn pause no-Btn-bg",
    attrs: {
      "ripple": false,
      "flat": "",
      "id": "pause"
    },
    nativeOn: {
      "click": function($event) {
        _vm.pause()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_pause.svg",
      "height": "26"
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "player-control-btn no-Btn-bg",
    attrs: {
      "ripple": false,
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.skip('next')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_skip.svg",
      "width": "20"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "player-options text-center"
  }, [_c('v-icon', {
    on: {
      "click": function($event) {
        _vm.optionModalActive = true
      }
    }
  }, [_vm._v("more_horiz")]), _vm._v(" "), (_vm.optionModalActive) ? _c('transition', {
    attrs: {
      "name": "slide-up",
      "leave-active-class": "slide-fade"
    }
  }, [_c('div', [_c('div', {
    staticClass: "decoy",
    on: {
      "click": function($event) {
        _vm.optionModalActive = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "option-modal"
  }, [_c('div', {
    staticClass: "follow-user"
  }, [_c('user-tag', {
    attrs: {
      "user": _vm.user,
      "showAvatar": "",
      "showUserType": "",
      "width": "35",
      "height": "35"
    }
  }), _vm._v(" "), (_vm.currentUser && _vm.item.user.id != _vm.currentUser.id) ? _c('user-follow-btn', {
    attrs: {
      "user": _vm.item,
      "theme": "dark",
      "type": "player"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "action-wrapper"
  }, [_c('div', {
    staticClass: "_action _border_right _border_bottom",
    on: {
      "click": function($event) {
        _vm.openShareModal()
      }
    }
  }, [_c('img', {
    staticClass: "_action-icon mr-1",
    attrs: {
      "src": "/static/images/ic_share_fill.svg",
      "width": "20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "_action-title"
  }, [_vm._v("Share")])]), _vm._v(" "), _c('div', {
    staticClass: "_action _border_bottom",
    on: {
      "click": function($event) {
        _vm.repostItem()
      }
    }
  }, [_c('img', {
    staticClass: "_action-icon mr-1",
    attrs: {
      "slot": "activator",
      "src": "/static/images/ic_repost.svg",
      "width": "20"
    },
    slot: "activator"
  }), _vm._v(" "), _c('div', {
    staticClass: "_action-title"
  }, [_vm._v("Repost")])]), _vm._v(" "), _c('div', {
    staticClass: "_action _border_right",
    on: {
      "click": function($event) {
        _vm.showAlbumCredit()
      }
    }
  }, [_c('img', {
    staticClass: "_action-icon mr-1",
    attrs: {
      "src": "/static/images/ic_users_fill.svg",
      "width": "20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "_action-title"
  }, [_vm._v("Credits")])]), _vm._v(" "), _c('div', {
    staticClass: "_action",
    on: {
      "click": function($event) {
        _vm.showComments()
      }
    }
  }, [_c('img', {
    staticClass: "_action-icon mr-1",
    attrs: {
      "src": "/static/images/ic_comment.svg",
      "width": "20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "_action-title"
  }, [_vm._v("Comment")])])])])])]) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.modalMode),
      callback: function($$v) {
        _vm.modalMode = $$v
      },
      expression: "modalMode"
    }
  }, [(_vm.showShareModal) ? _c('share-modal', {
    attrs: {
      "item": _vm.item,
      "dismiss": _vm.dismissShareDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showDownloadModal) ? _c('download-modal', {
    attrs: {
      "item": _vm.item,
      "track": _vm.track,
      "dismiss": _vm.dismissDownloadDialog
    }
  }) : _vm._e()], 1)], 1) : _c('div', {
    staticClass: "no-album-info"
  }, [_vm._v("\n    No music to play\n  ")]), _vm._v(" "), _c('mobile-comments', {
    ref: "mobileComments",
    attrs: {
      "item": _vm.item,
      "comments": _vm.comments
    }
  }), _vm._v(" "), (_vm.item) ? _c('div', {
    staticClass: "credits-dialog-wrapper"
  }, [_c('v-dialog', {
    staticClass: "album-credits-dialog",
    attrs: {
      "scrollable": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.showCredit),
      callback: function($$v) {
        _vm.showCredit = $$v
      },
      expression: "showCredit"
    }
  }, [_c('v-card', {
    staticClass: "album-dialog-body"
  }, [_c('v-card-title', [_vm._v("Album Credits")]), _vm._v(" "), _c('v-btn', {
    staticClass: "dialog-close-btn",
    on: {
      "click": function($event) {
        _vm.showCredit = false
      }
    }
  }, [_c('v-icon', [_vm._v("highlight_off")])], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "height": "300px"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Album Name: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._v(_vm._s(_vm.item.name))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Release Date: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.item.released_at)))])]), _vm._v(" "), (_vm.item.location && _vm.item.location != '') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Location: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._v(_vm._s(_vm.item.location))])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Genre: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._v(_vm._s(_vm.genres))])]), _vm._v(" "), (_vm.item.collaborators && _vm.item.collaborators.length > 0) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Collaborators: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._l((_vm.item.collaborators), function(c) {
    return [_c('div', {
      key: ("collaborator-" + (c.id)),
      staticClass: "collaborator-info"
    }, [_c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": ("/" + (c.user.slug))
      }
    }, [_vm._v(_vm._s(c.user.username))]), _vm._v(" "), _c('span', [_vm._v(" - " + _vm._s(c.user_role))])], 1)]
  })], 2)]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Contributors: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_c('div', {
    staticClass: "contributor-info"
  }, [_c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": ("/" + (_vm.item.user.slug))
    }
  }, [_vm._v(_vm._s(_vm.item.user.username))]), _vm._v(" "), _c('span', [_vm._v(" - Uploader")])], 1)]), _vm._v(" "), (_vm.item.contributors && _vm.item.contributors.length > 0) ? _c('label', {
    staticClass: "album-info-text"
  }, [_vm._l((_vm.item.contributors), function(c) {
    return [_c('div', {
      key: ("contributor-" + (c.id)),
      staticClass: "contributor-info"
    }, [_c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": ("/" + (c.user.slug))
      }
    }, [_vm._v(_vm._s(c.user.username))]), _vm._v(" "), _c('span', [_vm._v(" - " + _vm._s(c.user_role))])], 1)]
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.item.samplings && _vm.item.samplings.length > 0) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Samples: ")]), _vm._v(" "), (_vm.item.samplings && _vm.item.samplings.length > 0) ? _c('label', {
    staticClass: "album-info-text"
  }, [_vm._l((_vm.item.samplings), function(s) {
    return [_c('div', {
      key: ("sampling-" + (s.id)),
      staticClass: "sampling-info"
    }, [_c('label', [_vm._v(_vm._s(s.sampling_track.name))]), _vm._v(": "), _c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": ("/" + (s.sample_user.slug))
      }
    }, [_vm._v(_vm._s(s.sample_user.username))]), _vm._v(" "), _c('span', [_vm._v(" - " + _vm._s(s.sample_track.name))])], 1)]
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.item.labels && _vm.item.labels.length > 0) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Label: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": ("/" + (_vm.item.labels[0].user.slug))
    }
  }, [_vm._v(_vm._s(_vm.item.labels[0].user.username))])], 1)]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "album-info-label"
  }, [_vm._v("About the album:")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._v(_vm._s(_vm.item.description))])])], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-wrapper"
  }, [_c('img', {
    staticClass: "_logo",
    attrs: {
      "src": require("../../static/images/nav_logo_primary.png"),
      "width": "130"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36d219e2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile_player.vue
// module id = 1680
// module chunks = 180